import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// cookie 依赖文件
import cookie from './assets/cookie/cookie.js';
Vue.use(ElementUI);
Vue.prototype.$axios = axios;

// 视频依赖模块
import vueMiniPlayer from 'vue-mini-player'
import 'vue-mini-player/lib/vue-mini-player.css'
Vue.use(vueMiniPlayer)

// 引入日期选择组件
import vueHashCalendar from 'vue-hash-calendar'
import 'vue-hash-calendar/lib/vue-hash-calendar.css'
Vue.use(vueHashCalendar)

// 引入动画组件
import 'animate.css';

/* 设置全局请求基路径 */
// axios.defaults.baseURL = 'http://43.143.226.176:30001'; //正匠线上测试服请求地址
// axios.defaults.baseURL = 'http://101.201.60.249:8780'; //九丰线上正式服请求地址

axios.defaults.baseURL = 'https://api-duihuan.gifttalk.com.cn'; //九丰线上正式服请求地址
// axios.defaults.baseURL = 'http://192.168.0.103:30001'; // 正匠科技本地请求地址
//axios.defaults.baseURL = '/apis';
// axios.defaults.baseURL2 = 'http://43.143.226.176:8779'; //后台-正匠线上测试服请求地址
axios.defaults.baseURL2 = 'http://101.201.60.249:8779'; //后台-九丰线上正式服请求地址

var $this = new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')


// http request 拦截器
axios.interceptors.request.use(
	config => {
		const token = cookie.getCookie('web_token')
		if(token) { // 判断是否存在token，如果存在的话，则每个http header都加上token
			config.headers.token = token //请求头加上token
		}
		return config
	},
	err => {
		return Promise.reject(err)
	})

Vue.config.productionTip = false

// 添加响应拦截器
axios.interceptors.response.use(function(response) {
	// 对响应数据做点什么
	return response;
}, function(error) {
	ElementUI.Message.error('请求异常，请稍后重试!');
	// 对响应错误做点什么
	return Promise.reject(error);
});

